import { ParsedUserProduct } from '@/queries/products/types';
import { useSelector } from '@/redux/helper';
import {
  selectHasEducatorFeature,
  selectHasExclusiveProduct,
  selectHasFullHighlights,
  selectHasGuidedExperienceFeature,
} from '@/redux/selectors/users';

import { resolveUpsellProduct, type UpsellType } from './utils';

/** Reads the feature/persona selectors an upsell decision needs, so detail views pass only the two real inputs. */
const useResolveUpsellProduct = (
  userProduct: ParsedUserProduct,
  activeUserProducts: ParsedUserProduct[],
): UpsellType | null => {
  const hasGuidedExperience = useSelector(selectHasGuidedExperienceFeature);
  const hasExclusiveProduct = useSelector(selectHasExclusiveProduct);
  const hasFullHighlights = useSelector(selectHasFullHighlights);
  const hasEducatorFeature = useSelector(selectHasEducatorFeature);
  const isEducator = useSelector((state) => state.user.persona === 'educator');

  return resolveUpsellProduct({
    userProduct,
    activeUserProducts,
    hasGuidedExperience,
    hasExclusiveProduct,
    hasFullHighlights,
    hasEducatorFeature,
    isEducator,
  });
};

export default useResolveUpsellProduct;
